/* eslint-disable @typescript-eslint/naming-convention */
export enum attributeTypesEnum {
    simple,
    date,
    user,
    simpleList,
    sentiment,
    audienceReach,
    adValueUsd,
    number,
    wordCount,
    url,
    customList,
    duration,
    prominence,
    utcOffsetDate,
    domainAuthority,
    percent,
    language,
    engagement,
    multiDate,
    license
}
